import React from "react";
import axios from "axios";
import Cotizacion from "../../components/Cotizacion/Cotizacion";
import Cotizacion2 from "../../components/Cotizacion/Cotizacion2";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  consultarPlacaFetch,
  listarTerritoriosFetch,
  listarAccesoriosFetch,
  setConsultaPlaca,
  setDatosPersona,
  listarColoresFetch,
  fetchSetPoliticasDeducibles,
  listarECivilesFetch,
  listarGenerosFetch,
  fetchCotizadoresPermisos,
  listarParentescosFetch,
  obtenerTipoCombustiblePorMarcaModeloFetch,
} from "../../redux/actions/aCotizacion";
import { runInThisContext } from "vm";
import {
  FetchModificarCarrito,
  limpiarDatosCarrito,
} from "../../redux/actions/ACarritoProductos";
import {
  ambienteAplicacion,
  urlPlaceToPayCotizacion,
} from "../..//constants/urls";
import { loginClienteFinalFetch } from "../../redux/actions/aLogin";
import ErrorPage from "../../components/ErrorPage";
import { PermisosCotizadores } from "../../constants";
//import Perfil from "components/Perfil/Perfil";
//import Rcontrasena from "components/Login/Recuperar_contrasena";
//import Camcontrasena from "components/Perfil/Cambiar_contrasena";

class ContainerCotizacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canal: null,
      codigoProductoEspecial: this.getIdentifier(),
    };
  }

  getIdentifier() {
    // guardar el identificador del cotizador actual
    const queryParams = new URLSearchParams(this.props.location.search);
    // acceder al parametro de url
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    if (codigoProductoEspecial === null || (codigoProductoEspecial != 'vehiculosKilometrosPaquete' && codigoProductoEspecial != 'comparador' && codigoProductoEspecial != 'pits' && codigoProductoEspecial != 'KilometrosConsumidos')) {
      codigoProductoEspecial = '';
    }
    // return
    return codigoProductoEspecial;
  }

  async componentDidMount() {

    this.props.listarTerritorios();
    this.props.listarAccesorios();
    this.props.listarColores(this.state.codigoProductoEspecial =='comparador' || 'pits' ?this.state.codigoProductoEspecial:null);
    this.props.setPoliticasDeducibles(this.state.codigoProductoEspecial =='comparador' || 'pits' ?true:null);
    this.props.listarEciviles();
    this.props.listarParentescos({traerParentescoTitular: true});
    this.props.listarGeneros();
    this.verificarLog();
  }
  verificarLog = async () => {
    if (!this.props.datosUsuarios.userIsLoggedIn) {
      var data = {
        carDatosAsesor: {
          nombre: "AIG Metropolitana",
          codigoCore: "5c5c948f039b4c3d6745c048",
          sucursalSeleccionada: "001",
          ambiente: "local",
          brokerRUC: "1790475247001",
          brokerCodigo: "2-66",
          brokerMongo: "5ceeee1dec3de82e53146dda",
          brokerNombre: "AIG Metropolitana",
        },
      };
      await this.props.loginClienteFinal(data);

      setTimeout(() => {
        console.log("ClientFinalLogger", this.props);
        this.setState({
          canal: "PORTAL",
        });
      }, 500);
    }
  };

  onClickConsultar = (datos) => {
    console.clear();
    console.log('data', datos);
    const placa = datos.placa;
    const accion = datos.accion;
    const esKilometrosPaquete = datos.esKilometrosPaquete;
    const esComparador = datos.esComparador;

    var idCarrito = (
        this.props.datosCarrito &&
        this.props.datosCarrito.productosCarrito &&
        this.props.datosCarrito.productosCarrito.idCarrito
    ) ? this.props.datosCarrito.productosCarrito.idCarrito : '';
    this.consultaPlaca(placa, accion, esKilometrosPaquete, esComparador, idCarrito);

  };
  async consultaPlaca(placa, accion, esKilometrosPaquete, esComparador, idCarrito) {
    await this.props.consultarPlaca(placa, esKilometrosPaquete, esComparador, idCarrito);

    if (this.props.datosCotizacion.datosPlaca.transaccion) {
      if (
        !this.props.datosCotizacion.datosPlaca.mostrarMarcas &&
        !this.props.datosCotizacion.datosPlaca.mostrarModelos &&
        !this.props.datosCotizacion.datosPlaca.mostrarPropietario &&
        !this.props.datosCotizacion.datosPlaca.mostrarMotor &&
        !this.props.datosCotizacion.datosPlaca.mostrarChasis &&
        !this.props.datosCotizacion.datosPlaca.mostrarAnio &&
        !this.props.datosCotizacion.datosPlaca.mostrarAvaluo
      ) {
        //console.log("------------------------------- ", this.props.datosCarrito.datosPlaca)
        //Verificar Validacion de Restricciones
        if (
          this.props.datosCotizacion.datosPlaca.mostrarMensajeRestriccion ===
          false
        ) {
          await this.llenarDatosPrima(accion);

          if (!this.props.datosCarrito.hasErrored) {
            //console.log("------------------------------- ", this.props.datosCarrito.hasErrored)
            //this.props.history.replace('/datos-cotizacion')
            this.props.history.push({
              pathname: "/datos-cotizacion",
              search: `?accion=agregar`,
            });
          }
        }
      }
    }
  }

  async llenarDatosPrima(accion) {
    let error = false;

    //console.log("LACCION ES ", accion)

    let datosPlaca = this.props.datosCotizacion.datosPlaca;
    //console.log("formulario continuar llamdardaots ", datosPlaca)

    const datosAccesorios = {
      accesorios: [],
      valorAccesorios: 0,
    };
    datosPlaca.datosAccesorios = datosAccesorios;

    if (!error) {
      delete datosPlaca.arrayMarcas;
      delete datosPlaca.marcaSeleccionada;
      delete datosPlaca.arrayModelos;
      delete datosPlaca.modeloSeleccionado;
      datosPlaca.rastreoSatelital = false;
      datosPlaca.valorAsegurado =
        datosPlaca.valor_avaluo === undefined || datosPlaca.valor_avaluo === ""
          ? "18000"
          : datosPlaca.valor_avaluo;

      //Agregar array de Amparos Adicionales
      const ValorAmparosAdicionales = {
        gastosMedicos: true,
        accidentesPersonales: true,
        gastosTransporte: false,
        amparoPatrimonial: false,
        objetosOlvidados: false,
        gastosFunerarios: false,
        amparoSustituto: true,
        llaveProtegida: true,
        documentosProtegidos: true,
      };
      datosPlaca.amparos = ValorAmparosAdicionales;

      this.props.setDatosPlaca(datosPlaca);

      let datosPersona = this.props.datosCotizacion.datosPersona;
      datosPersona.codigoTerritorio = "1";
      datosPersona.provCodigoCore = "9";
      datosPersona.paiCodigoCore = "1";
      //cambiar ----  esta cambiado
      if (!datosPersona.codigoGenero) datosPersona.codigoGenero = "1";

      this.props.setDatosPersona(datosPersona);

      const datosCarrito = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        cliCodigoCore: "",
        datosProducto: datosPlaca,
        datosCliente: this.props.datosCotizacion.datosPersona,
        datosCoberturas: [],
        datosAmparos: [],
        placa: datosPlaca.placa,
        accion: "agregar",
        carCodigo:
          accion === "nuevo" || accion === undefined
            ? ""
            : this.props.datosCarrito.productosCarrito.idCarrito,
        mostrarPropietarioCarritoReact: false,
        datosAsesor: {
          nombre: `${this.props.datosUsuarios.nombres} ${this.props.datosUsuarios.apellidos}`,
          codigoCore: this.props.datosUsuarios.cliCodigoCore,
          sucursalSeleccionada: this.props.datosSucursales
            .sucursalSelecionadaAsesor,
          amparosAdicionales: ValorAmparosAdicionales,
          ambiente: ambienteAplicacion,
          emailAsesor: this.props.datosUsuarios.correo
            ? this.props.datosUsuarios.correo
            : "",
          brokerRUC: this.props.datosUsuarios.brokerRUC
            ? this.props.datosUsuarios.brokerRUC
            : "",
          brokerNombre: this.props.datosUsuarios.brokerNombre
            ? this.props.datosUsuarios.brokerNombre
            : "",
          brokerCodigo: this.props.datosUsuarios.brokerCodigo
            ? this.props.datosUsuarios.brokerCodigo
            : "",
        },
        esCotizacion: false,
        amparosAdicionales: ValorAmparosAdicionales,
        canal: this.state.canal,
      };
      const datosCarritoJSON = JSON.stringify(datosCarrito);
      console.log("Enviar Carrito ", datosCarritoJSON);

      await this.props.modificarCarrito(datosCarrito);
    }
  }

  render() {
    return (
      this.state.codigoProductoEspecial != '' ?
        <main className="bg-light">
          <div className="cr-content container-fluid">
            <div className="container-body-spaces">
              <Cotizacion
                onClickConsultar={this.onClickConsultar}
                datosPlaca={this.props.datosCotizacion.datosPlaca}
                loggedIn={this.props.loggedIn}
                canal={this.state.canal}
                obtenerTipoCombustiblePorMarcaModelo={this.props.obtenerTipoCombustiblePorMarcaModelo}
              />
            </div>
          </div>
        </main> :
        <ErrorPage mainText={this.state.codigoProductoEspecial != '' ? PermisosCotizadores.msgSinAcceso : PermisosCotizadores.msgSinProductoAuto} />


    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosSucursales: state.datosSucursales,
});
console.log("mapStateToProps", mapStateToProps);
const mapDispatchToProps = (dispatch) => {
  return {
    consultarPlaca: (placa, esKilometrosPaquete, esComparador, idCarrito) =>
      dispatch(consultarPlacaFetch(placa, esKilometrosPaquete, esComparador, idCarrito)),
    listarTerritorios: () => dispatch(listarTerritoriosFetch()),
    listarAccesorios: () => dispatch(listarAccesoriosFetch()),
    listarColores: (productoEspecial) => dispatch(listarColoresFetch(productoEspecial)),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
    setDatosPersona: (datos) => dispatch(setDatosPersona(datos)),
    modificarCarrito: (datos) => dispatch(FetchModificarCarrito(datos)),
    setPoliticasDeducibles: (esComparador) => dispatch(fetchSetPoliticasDeducibles(esComparador)),
    listarEciviles: () => dispatch(listarECivilesFetch()),
    listarParentescos: (datos) => dispatch(listarParentescosFetch(datos)),
    listarGeneros: () => dispatch(listarGenerosFetch()),
    loginClienteFinal: (data) => dispatch(loginClienteFinalFetch(data)),
    obtenerTipoCombustiblePorMarcaModelo: (marca, modelo) => dispatch(obtenerTipoCombustiblePorMarcaModeloFetch(marca, modelo)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContainerCotizacion)
);
